import VideoPrevious from "./VideoPrevious";
import VideoBackword from "./VideoBackword";
import VideoForward from "./VideoForward";
import VideoPlay from "./VideoPlay";
import VideoPause from "./VideoPause";
import VideoNext from "./VideoNext";
import FullScreenOpen from "./FullScreenOpen";
import FullScreenClose from "./FullScreenClose";
import PlayAgain from "./PlayAgain";

export {
  VideoPrevious,
  VideoBackword,
  VideoForward,
  VideoPlay,
  VideoPause,
  VideoNext,
  FullScreenClose,
  FullScreenOpen,
  PlayAgain,
};
